// TODO: remove code above and fix issues in case changing this file
/* eslint-disable no-undef */
'use strict';

(function () {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileInsuranceReg', cobCarrierProfileInsuranceReg);

	cobCarrierProfileInsuranceReg.$inject = [
		'$timeout', 'sessionService', 'Upload', 'subjectObserverMessagesService', 'observerService',
		'carrierRegistrationService', '$location', 'validationService', '$stateParams'
	];

	var $timeout,
		sessionService,
		ngFileUpload,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		$location,
		subjectMessages,
		observerMessages,
		validationService,
		$stateParams;

	function cobCarrierProfileInsuranceReg(_$timeout_,
		_sessionService_,
		_ngFileUpload_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_$location_,
		_validationService_,
		_$stateParams_) {
		$timeout = _$timeout_;
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		ngFileUpload = _ngFileUpload_;
		$location = _$location_;
		validationService = _validationService_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileInsuranceReg.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				loaded: false,
				toggleFeedbackForm: false,
				agents: [],
				feedbackAgents: [],
				addNewRow: false,
				feedbackDate: '',
				otherFeedback: '',
				feedbackError: [],
				submitted: false,
				showSectionMessage: false,
				showSectionSubmitMessage: false,
				registryDate: ''
			};
			scope.goToTab = goToTab;
			scope.onForceGo = onForceGo;
			scope.sortCoverage = sortCoverage;
			scope.sortCoverageRows = sortCoverageRows;
			scope.toggleFeedback = toggleFeedback;
			scope.addNewRow = addNewRow;
			scope.deleteRow = deleteRow;
			scope.onDiscardFileClick = onDiscardFileClick;
			scope.onFileUploadStart = onFileUploadStart;
			scope.setIsDirty = setIsDirty;
			scope.validateFile = validateFile;
			scope.validateCoverage = validateCoverage;
			scope.validateName = validateName;
			scope.validatePhone = validatePhone;
			scope.validateFax = validateFax;
			scope.validateEmail = validateEmail;
			scope.getDate = getDate;
			scope.onSubmit = onSubmit;
			scope.deleteAll = deleteAll;

			registerObserverHandlers();
			$timeout(function () {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
			},
			100);
		}

		function loadData(data) {
			scope.m.agents = [];
			scope.m.insuranceMessage = data.insuranceMessage;
			scope.m.brokerName = data.brokerName;
			scope.m.feedbackDate = Date.parse(data.agents.feedbackDate);
			scope.m.registryDate = Date.parse(data.agents.registryDate);
			angular.forEach(data.agents.agents,
				function (agent) {
					var regAgent = {
						coverage: agent.coverage,
						policy: agent.policy,
						phone: agent.phone
					};
					sortCoverage(regAgent);
					scope.m.agents.push(regAgent);
				});
			scope.m.loaded = true;
		}

		function setIsDirty() {
			scope.m.isDirty = true;

			window.onbeforeunload = function () {
				return 'Your feedback has not been submitted. If you leave this page any feedback will be lost. To submit your feedback, click the Submit button at the bottom of the page.';
			};
		}

		function canLeaveFeedback() {
			if (scope.m.feedbackDate > scope.m.registryDate) {
				scope.m.submitted = !scope.m.submitted;

				return false;
			} else {
				return true;
			}
		}

		function sortCoverage(regAgent) {
			var formattedCoverage = [];
			if (regAgent.coverage) {
				formattedCoverage = regAgent.coverage.map(function (coverageType) {
					if (coverageType === 'AUTO') {
						coverageType = ' Auto';
					}
					if (coverageType === 'CARGO') {
						coverageType = ' Cargo';
					}
					if (coverageType === 'GENERAL') {
						coverageType = ' General';
					}
					if (coverageType === 'WORKERS_COMP') {
						coverageType = ' Workers\' Comp';
					}

					return coverageType;
				});
			}
			formattedCoverage.sort();
			regAgent.formattedCoverage = formattedCoverage;
		}

		function sortCoverageRows(coverageRows) {
			coverageRows.sort(function (a, b) {
				if (a.formattedCoverage[0] < b.formattedCoverage[0]) {
					return -1;
				}
				if (a.formattedCoverage[0] > b.formattedCoverage[0]) {
					return 1;
				}

				return 0;
			});
		}

		function toggleFeedback() {
			if (canLeaveFeedback() && !scope.m.toggleFeedbackForm) {
				scope.m.toggleFeedbackForm = true;
				if (scope.m.feedbackAgents.length === 0) {
					addNewRow();
				}
			} else {
				scope.m.toggleFeedbackForm = false;
			}
		}

		function addNewRow() {
			scope.m.addNewRow = true;
			var feedbackAgent = {};
			var errors = {};
			scope.m.feedbackError.push(errors);
			scope.m.feedbackAgents.push(feedbackAgent);
		}

		function deleteRow(deletedRow) {
			scope.m.feedbackAgents.splice(deletedRow, 1);
			scope.m.feedbackError.splice(deletedRow, 1);
		}

		function deleteAll() {
			scope.m.feedbackAgents = [];
			scope.m.feedbackError = [];
			scope.m.isDirty = false;
		}

		function onDiscardFileClick(feedbackAgent) {
			feedbackAgent.certificateFileName = undefined;
		}

		function onFileUploadStart(feedbackAgent, index) {
			if (feedbackAgent.fileUploaderFile) {
				setIsDirty();
				if (validateFile(feedbackAgent, index)) {
					ngFileUpload.base64DataUrl(feedbackAgent.fileUploaderFile, false)
						.then(function (url) {
							feedbackAgent.certificateContent = url.split(',')[1];
							feedbackAgent.certificateFileName = feedbackAgent.fileUploaderFile.name;
							feedbackAgent.certificateMimeType = feedbackAgent.fileUploaderFile.type;
						});

				} else {
					scope.m.feedbackError[index]
						.fileError = 'Only .pdf, .tif, .tiff, .jpg, .jpeg .png or .gif under 10mb allowed.';
				}
			}
		}

		function getDate() {
			scope.m.feedbackDate = new Date();
		}

		function validateCoverage(feedbackAgent, index) {
			if (!feedbackAgent.HasAuto &&
                !feedbackAgent.HasCargo &&
                !feedbackAgent.HasWorkersComp &&
                !feedbackAgent.HasGeneral) {
				scope.m.feedbackError[index].coverageError = 'Please select at least one option';
			} else {
				scope.m.feedbackError[index].coverageError = '';
			}
		}

		function validateName(feedbackAgent, index) {
			if (!feedbackAgent.AgentName) {
				scope.m.feedbackError[index].nameError = 'Valid input is required';
			} else {
				scope.m.feedbackError[index].nameError = '';
			}
		}

		function validatePhone(feedbackAgent, index) {
			if (!feedbackAgent.Phone) {
				scope.m.feedbackError[index].phoneError = 'Valid input is required';
			} else if (feedbackAgent.Phone.length !== 10) {
				scope.m.feedbackError[index].phoneError = 'Valid input is required';
			} else if (feedbackAgent.Phone[0] === '1' || feedbackAgent.Phone[0] === '0') {
				scope.m.feedbackError[index].phoneError = 'Valid input is required';
			} else {
				scope.m.feedbackError[index].phoneError = '';
			}
		}

		function validateFax(feedbackAgent, index) {
			if (feedbackAgent.Fax && feedbackAgent.Fax.length !== 10) {
				scope.m.feedbackError[index].faxError = 'Valid input is required';
			} else if (feedbackAgent.Fax && (feedbackAgent.Fax[0] === '1' || feedbackAgent.Fax[0] === '0')) {
				scope.m.feedbackError[index].faxError = 'Valid input is required';
			} else {
				scope.m.feedbackError[index].faxError = '';
			}
		}

		function validateEmail(feedbackAgent, index) {
			if (feedbackAgent.Email && !validationService.isValidEmail(feedbackAgent.Email)) {
				scope.m.feedbackError[index].emailError = 'Valid email is required';
			} else {
				scope.m.feedbackError[index].emailError = '';
			}
		}

		function validateFile(feedbackAgent) {
			var validMimeTypes = [
				'application/pdf', 'image/tiff', 'image/png', 'image/jpeg',
				'image/gif'
			];
			if (validMimeTypes.indexOf(feedbackAgent.fileUploaderFile.type) > -1) {
				if (feedbackAgent.fileUploaderFile.size < 10485760) {
					return true;
				}
			}

			return false;
		}

		function validateAgent(feedbackAgent, key) {
			validateCoverage(feedbackAgent, key);
			validateName(feedbackAgent, key);
			validatePhone(feedbackAgent, key);
			validateFax(feedbackAgent, key);
			validateEmail(feedbackAgent, key);
			if (scope.m.feedbackError[key].coverageError ||
                scope.m.feedbackError[key].nameError ||
                scope.m.feedbackError[key].phoneError ||
                scope.m.feedbackError[key].faxError ||
                scope.m.feedbackError[key].emailError) {
				return false;
			} else {
				return true;
			}
		}

		function validateAgents() {
			var isValid = true;
			angular.forEach(scope.m.feedbackAgents,
				function (feedbackAgent, key) {
					if (!validateAgent(feedbackAgent, key)) {
						isValid = false;
					}
				});

			return isValid;
		}

		function registerObserverHandlers() {

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_INSUREANCE_REG_LOADED, handler: loadData },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);
			scope.$on('$destroy',
				function () {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function (event) {
					if (scope.m.isDirty) {
						if (!scope.ux_requirement_hack_for_scrolling) {
							if (!
							confirm('Your feedback has not been submitted. If you leave this page any feedback will be lost. To submit your feedback, click the Submit button at the bottom of the page. Are you sure you want to leave the page?')) {
								event.preventDefault();
							}
						}
					}

					scope.ux_requirement_hack_for_scrolling = false;
				});
		}

		function onSubmit() {
			if (!scope.m.loaded) {
				return;
			} else {
				if (validateAgents()) {
					scope.m.toggleFeedbackForm = false;
					scope.m.showSectionSubmitMessage = false;
					setSectionMessage(false);
					getDate();
					scope.m.submitted = true;

					var carrierId = -1;

					if ($stateParams.carrierId)
						carrierId = $stateParams.carrierId;

					setTimeout(function () {
						observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
					}, 1);

					carrierRegistrationService
						.submitRegistryInsuranceInfo(carrierId, scope.m.feedbackAgents, scope.m.otherFeedback)
						.then(function () {
							if (typeof (callback) === 'function')
								callback();
						}).finally(function () {
							observerService
								.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
						});
				}
			}
		}

		function scrollTop() {
			$timeout(function () {
				scope.ux_requirement_hack_for_scrolling = true;
				$('.profile-insurance-reg')
					.animate({
						scrollTop: $('#error-summary').offset().top
					},
					200);
				setIsDirty();
			},
			1);
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}

		function saveData(callback) {
			if (!scope.m.loaded) {
				return;
			}
			if ((!scope.m.isDirty || scope.m.submitted) && typeof (callback) === 'function') {
				callback();
			} else if (validateAgents() && !scope.m.submitted) {
				scope.m.showSectionSubmitMessage = true;
				setSectionMessage(false);
				scrollTop();
			} else if (!validateAgents() && !scope.m.submitted) {
				scope.m.showSectionSubmitMessage = false;
				setSectionMessage(true);
				scrollTop();
			}
			scope.pendingCallback = callback;
		}

		function setSectionMessage(show) {
			scope.m.showSectionMessage = show;
			if (show) {
				$timeout(function () {
					$('.carrier-profile-wrapper')
						.animate({
							scrollTop: $('#error-summary').offset().top
						},
						200);
				},
				10);
			}
		}
	}

})();
